import Vue from 'vue';
import VueAuth from '@websanova/vue-auth';
import auth from "./auth_token.js";
import http from "@websanova/vue-auth/drivers/http/axios.1.x.js";
import router from "@websanova/vue-auth/drivers/router/vue-router.2.x.js";
import authorization from "./authorization";

// really hacky auto log in :(
let parseUserData = function(data) {
    // decode auth token to get login time (base 64 and joined with ;)
    let decodedToken = atob(decodeURIComponent(data.auth_token)).split(';');

    let authTime     = parseInt(decodedToken.pop());
    let userId       = parseInt(decodedToken.pop());

    let parsedData = {
        id:                  userId,
        name:                data.user_name,
        company:             data.user_company,
        token:               data.auth_token,
        authTime:            authTime,
        validUntil:          authTime + (60 * 60), // now plus 1 hour
        allowedResources:    data.allowed_resources || {},
        loggedInByAuthToken: !!data.loggedInByAuthToken
    };

    authorization.setAllowedResources(parsedData.allowedResources);

    return parsedData;
};

const urlParams = new URLSearchParams(window.location.search);
let userData = {
    auth_token:          urlParams.get('authToken'),
    user_name:           urlParams.get('userName'),
    user_company:        urlParams.get('userCompany'),
    allowed_resources:   urlParams.get('allowedResources'),
    loggedInByAuthToken: !!urlParams.get('authToken')
};

if (userData.allowed_resources) {
    userData.allowed_resources = atob(userData.allowed_resources);
    try {
        userData.allowed_resources = JSON.parse(userData.allowed_resources);
    } catch (e) {
        userData.allowed_resources = {};
    }
} else {
    userData.allowed_resources = {};
}

if (
    typeof userData.auth_token === 'string'
    && userData.auth_token.trim() !== ''
) {
    let user = parseUserData(userData);

    window.localStorage.setItem("auth_remember",       JSON.stringify(user));
    window.localStorage.setItem("auth_stay_signed_in", 'true');
    window.localStorage.setItem("auth_token_default",  urlParams.get('authToken'));
}

Vue.use(VueAuth, {
    auth,
    http,
    router,
    // registerData: {url: '/api/register', method: 'POST', redirect: '/'},
    loginData: {
        url: '/api/login',
        method: 'POST',
        redirect: '/',
        fetchUser: true,
    },
    logoutData: {
        url: '/auth/logout',
        method: 'GET',
        redirect: '/login',
        makeRequest: true,
    },
    fetchData: {url: '/api/user', method: 'GET', enabled: false},
    refreshData: false,
    rolesKey: 'role',
    parseUserData: parseUserData,
//    tokenExpired: () => {
//        return false;
//    }
});
